// Desc: ClientDB page for admin
import React, { useState } from "react";
import { Tab, Button } from "semantic-ui-react";
import { BasicModal } from "../../../../components/Shared";
import {
  ClientDBcreatorList,
  ClientDBcreatorForm,
} from "../../../../components/Admin/ClientDBcreator";

import "./ClientDBcreator.scss";

export function ClientDBcreator() {
  const [showModal, setShowModal] = useState(false);
  const [reload, setReload] = useState(false);

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onReload = () => setReload((prevState) => !prevState);

  const panes = [
    {
      render: () => (
        <Tab.Pane attached={false}>
          <ClientDBcreatorList reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <>
      <div className="clientdb-page">
        <div className="clientdb-page__add">
          <Button primary onClick={onOpenCloseModal}>
            Nuevo Cliente
          </Button>
        </div>

        <Tab menu={{ secondary: true }} panes={panes} />
      </div>

      <BasicModal
        show={showModal}
        close={onOpenCloseModal}
        title="Crear nuevo cliente"
      >
        <ClientDBcreatorForm onClose={onOpenCloseModal} onReload={onReload} />
      </BasicModal>
    </>
  );
}
